import { render } from "./MaterialLoading.vue?vue&type=template&id=7f4de801&scoped=true"
import script from "./MaterialLoading.vue?vue&type=script&lang=js"
export * from "./MaterialLoading.vue?vue&type=script&lang=js"

import "./MaterialLoading.vue?vue&type=style&index=0&id=7f4de801&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4de801"]])

export default __exports__